import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { XMarkIcon, ArrowDownTrayIcon } from "@heroicons/react/24/solid";

const PDFViewerModal = ({ isOpen, closeModal }) => {
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-40" />
        </Transition.Child>

        <div className="fixed inset-0 flex items-center justify-center p-4 sm:p-8">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="flex flex-col w-full max-w-7xl h-full max-h-[90vh] rounded-xl overflow-hidden shadow-2xl">
              <div className="flex items-center justify-between px-5 py-3 bg-white border-b border-gray-200 shrink-0">
                <Dialog.Title
                  as="h3"
                  className="text-sm font-semibold text-gray-800 truncate"
                >
                  RAVL White Paper — Leap Left: AI-First Software Delivery
                </Dialog.Title>
                <div className="flex items-center gap-3 ml-4 shrink-0">
                  <a
                    href="/ravl-whitepaper.pdf"
                    download="RAVL-White-Paper.pdf"
                    className="flex items-center gap-1.5 text-sm text-purple-700 hover:text-purple-900 font-medium transition-colors"
                    title="Download PDF"
                  >
                    <ArrowDownTrayIcon className="h-4 w-4" />
                    <span className="hidden sm:inline">Download</span>
                  </a>
                  <button
                    onClick={closeModal}
                    className="p-1 rounded-md text-gray-500 hover:text-gray-800 hover:bg-gray-100 transition-colors"
                    title="Close"
                  >
                    <XMarkIcon className="h-5 w-5" />
                  </button>
                </div>
              </div>

              {/* PDF Viewer */}
              <div className="flex-1 bg-gray-100 overflow-hidden">
                <iframe
                  src="/ravl-whitepaper.pdf"
                  title="RAVL White Paper"
                  className="w-full h-full border-0"
                />
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
};

export default PDFViewerModal;
